'use strict';

(function (angular) {
    angular.module('zp').directive('sideNavTrigger', sideNavTrigger);

    /**@ngInject */
    function sideNavTrigger($rootScope) {
        return {
            restrict: 'A',
            link: link,
            replace: true,
            scope: {}
        };

        function link(scope, element) {
            element.on('click', function () {
                $rootScope.$emit('CLOSE_SIDE_MENU', null);
                if (!$rootScope.$$phase) {
                    $rootScope.$apply();
                }
            });
        }
    }
})(window.angular);